export interface ICity {
  id: number;
  name: string;
  hasEcoDelivery?: boolean;
  deliveryPrice: number | null;
  deliveryPoints: IDeliveryPoint[];
  deliveryTypes: EDeliveryType[];
  fiasId: string;
}

export enum EDeliveryType {
  COURIER = 'COURIER',
  DELIVERY_POINT = 'DELIVERY_POINT',
  METASHIP = 'METASHIP',
  POSTAMAT = 'POSTAMAT',
  RUSSIAN_POST = 'RUSSIAN_POST',
}

interface IDeliveryPoint {
  name: string | null;
  /** Срок хранения заказа */
  shelfLife: number | null;
  /** ID ПВЗ */
  id: number;
  /** Адрес ПВЗ */
  address: string;
  /** Ближайшая дата доставки */
  deliveryDate: any | null;
  /** Цена доставки */
  deliveryPrice: number | null;
  /** Тип ПВЗ */
  type: IDeliveryPointType;
  /** Есть ли примерочная */
  hasDressingRoom: boolean;
  /** Принимает ли возвраты */
  acceptReturns: boolean;
  /** Ограничено */
  disabled: boolean | null;
  /** Причина ограничения - устаревшее */
  disabledReason: string | null;
  /** Ссылка на иконку доступного и выбранного ПВЗ */
  iconAvailableSelectedUrl: string | null;
  /** Ссылка на иконку доступного ПВЗ */
  iconAvailableUrl: string | null;
  /** Ссылка на иконку недоступного и выбранного ПВЗ */
  iconUnavailableSelectedUrl: string | null;
  /** Ссылка на иконку недоступного ПВЗ */
  iconUnavailableUrl: string | null;
  /** Широта */
  latitude: number;
  /** Долгота */
  longitude: number;
  /** Расписание работы ПВЗ */
  schedule: {
    days: IScheduleDay;
  };
}

type IDeliveryPointType = 'DELIVERY_POINT' | 'MAGNIT_OFFICE' | 'MAGNIT_SHOP' | 'RUSSIAN_POST';

interface IScheduleDay {
  color: string;
  day: EDayOfWeek;
  timeFrom: string | null;
  timeTo: string | null;
}

enum EDayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}
